import styled, { css } from 'styled-components'

export const Container = styled.section`
    width: 100%;
    height: 100px;
    position: fixed;
    top: 0;
    background: transparent;
    transition: all .3s ease;
    color: #FFF;
    border-bottom: 1px solid  rgba(255, 255, 255, 0.1);

    ${props => !props.isScrollOnTop && css`
        background: #FFF;
        z-index: 9999;
        transform: translate3D(0px, 0px, 0px);
        box-shadow: rgb(43 83 135 / 8%) 0px 3px 8px 0px;
        color: #000;
    `}
`


export const Content = styled.div`
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 30px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    img{
        height: 3.75rem;

        @media (max-width: 610px) {
            height: 2.8rem;
        }
    }

    .buttons{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 0.5rem;

        button {
            background: rgb(209, 57, 124); 
            border: none;
            border-radius: 5px;
            width: 100%;
            min-height: 2.6rem;
            color: #FFF;
            font-weight: 500;
            transition: filter .3s;

            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;

            &:hover {
                filter: brightness(0.9);
            }

            @media (max-width: 610px) {
                min-height: 2.2rem;
                font-size: 0.9rem;
            }
        }

        .buttonLocation{
            font-size: 0.7rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 6.5rem;
            gap: 3px;

            p {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
    
            svg{
                font-size: 0.9rem;
                min-width: 0.9rem;
                transition: transform .3s;
            }

            &:hover {
                svg:last-child{
                    transform: translateX(5px);
                }
            }
        }
    }

`